import dynamic from "next/dynamic";

export const DynamicContent018 = dynamic(() => import("./Content018"), {
  suspense: true,
});
